var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikefilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 12.625C21.25 13.0891 21.0656 13.5342 20.7374 13.8624C20.4092 14.1906 19.9641 14.375 19.5 14.375H13.97L14.81 18.3737C14.8275 18.4612 14.8363 18.5575 14.8363 18.6538C14.8363 19.0125 14.6875 19.345 14.4513 19.5813L13.5238 20.5L7.76625 14.7425C7.4425 14.4188 7.25 13.9812 7.25 13.5V4.75C7.25 4.28587 7.43437 3.84075 7.76256 3.51256C8.09075 3.18438 8.53587 3 9 3H16.875C17.6012 3 18.2225 3.4375 18.485 4.0675L21.1275 10.2362C21.2063 10.4375 21.25 10.6475 21.25 10.875V12.625ZM2 3H5.5V13.5H2V3Z",
    fill: "#6D44E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikefilled);
export default __webpack_public_path__ + "static/media/dislikefilled.efd598ae104806a3d38464eb96c58efe.svg";
export { ForwardRef as ReactComponent };